/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, BOURBON){
	const a = 'is-active';
	const v = 'is-visible';
	const $map = location.pathname;

	//<ご予約状況>--------------------------------------------------------------------
	// <ご予約状況>現在年月から表示月を取得
	const current = new Date();
	let year = current.getFullYear();
	let month = current.getMonth() + 1;
	if (month === 12) { // 現在月が12月のときは年繰り上げ処理
		year += 1;
	}
	let $today = String(year) + ('0' + String(month)).slice(-2) +
				 ('0' + String(current.getDate())).slice(-2);

	// <ご予約状況>月ごとのカレンダーをセット
	const setCalendar = (_$cal, _dataArr, _year, _month, _start) => {
		if (_month > 12) {
			_month -= 12;
			_year += 1;
		}
		_$cal.parent('.viewing-calendar').find('.viewing-calendar-year span').text(_year);
		_$cal.parent('.viewing-calendar').find('.viewing-calendar-month span').text(_month);

		// 初日の曜日を取得
		const first = new Date(_year, _month - 1, 1);
		let firstDay = first.getDay() - 1;
		if (firstDay === -1) { firstDay = 6; }

		// カレンダー開始日以前を埋める
		if (_start > 1) {
			for (let i=0; i<_start - 1; i++) {
				_$cal.find('li').eq(i + firstDay).append(`<span>${i + 1}</span><span>-</span>`);
			}
		}

		// 日付ごとの値をセット
		_dataArr.forEach((val, idx) => {
			let setVal;
			let setStatus;
			let setTime = [];
			let inputDisabled = '';
			let $thisDate = `${String(_year)}年${String(_month)}月${String( _start + idx)}日`;
			let time1 = val[1];
			let time2 = val[2];
			let time3 = val[3];
			let available = val[4];
			let limited = val[5];
			let ng = val[6];
			let lastupdate = val[7];

			// 予約が入っている時間をセット
			// 9:00～
			if (time1 === '1') {
				setTime.push('９：００');
			}
			// 10:00～
			if(time2 === '1'){
				setTime.push('１０：００');
			}
			// 11:00～
			if(time3 === '1'){
				setTime.push('１１：００');
			}
			
			// ステータスをセット
			if(available === '1'){
				// 受け受け中
				setVal = '○';
				setStatus = 'available';
			} else if(limited === '1'){
				// 残りわずが
				setVal = '△';
				setStatus = 'limited';
			} else if(ng === '1'){
				// 受付不可
				setVal = '×';
				setStatus = 'ng';
				inputDisabled = 'disabled';
			} else {
				setVal = '';
				setStatus = '';
			}

			// 現在日以前の日付をdisabledにする
			let $thisDateComparison = String(_year) + ('0'+ String(_month)).slice(-2) +
				 ('0'+ String( _start + idx)).slice(-2);
			if($thisDateComparison <= $today) {
				inputDisabled = 'disabled';	
				setVal = '×';
				setStatus = 'ng';
			}

			_$cal.find('li').eq(_start - 1 + idx + firstDay).append(`<span class="js-date-select ${inputDisabled}"
			 data-date="${$thisDate}" data-time="${setTime}">
				<span>${_start + idx}</span>
				<span class="js-status" data-status="${setStatus}">${setVal}</span>`);
		});

		$('.viewing-calendar').matchHeight();
	};

	// <ご予約状況>CSV読み込み
	const csvLoad = () => {
		const req = new XMLHttpRequest();
		req.open('get', 'reception_calendar.csv', true);
		req.send(null);
		req.onload = function(){
			month = month < 12 ? (month - 1) : (month - 1) - 12;
			const month2 = (month + 1) < 12 ? (month + 1) : (month + 1) - 12;
			let tmp = req.responseText.split('\n');
			let dataArr1 = [], dataArr2 = [];

			tmp.shift(); // 見出し行削除
			tmp.forEach((val, idx) => {
				const data = val.split(',');
				const thisDate = new Date(data[0]);
				const thisYear = thisDate.getFullYear();
				const thisMonth = thisDate.getMonth();
				
				if (thisYear >= year && thisMonth === month) {
					dataArr1.push(data);
				} else if (thisYear >= year && thisMonth === month2) {
					if (month > month2) {
						if (thisYear > year) {
							dataArr2.push(data);
						}
					} else {
						dataArr2.push(data);
					}
				}
			});

			// 今月から2ヶ月分
			setCalendar($('#calendar-1'), dataArr1, year, month + 1, 1);
			setCalendar($('#calendar-2'), dataArr2, year, month + 2, 1);
			// 存在しない日付削除
			$('.js-status[data-status=""]').parents('li').remove();

		};
	}

	// <ご予約状況>カレンダー日付選択
	const radioChange = () => {
		let $action;
		let $thisTime;
		$('.js-date-select').on('click', (e) => {
			$('.viewing-calendar-data li').removeClass(a);
			$(e.currentTarget).parents('li').addClass(a);
			$thisTime = '&time=' + encodeURIComponent($(e.currentTarget).attr('data-time'));

			$action = `?date=${encodeURIComponent($(e.currentTarget).attr('data-date'))}${$thisTime}` ;

			$('.js-input-submit').attr('href', '/viewing/input2.html' + $action).removeClass('is-disable');
		});
	}

	// <お申込み情報入力>--------------------------------------------------------------------
	const zenkaku2Hankaku = (str) => {
		return str.replace(/[A-Za-z0-9]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
		});
	}
	const timeCheck = () => {
		// パラメータを配列に格納
		let paramTagArr = [];
		let pair = location.search.substring(1).split('&');
		for(let i = 0; pair[i]; i++) {
			let keyValue = pair[i].split('=');
			paramTagArr.push(keyValue[1]);
		}
		// 選択した日付
		let $thisDate = decodeURIComponent(paramTagArr[0]);
		// 予約できない時間
		let thisNgTimeArr = [];
		let $thisNgTime = decodeURIComponent(paramTagArr[1]);
		$thisNgTime = String($thisNgTime);
		for(let i = 0; i < $thisNgTime.split(',').length; i++) {
			thisNgTimeArr.push($thisNgTime.split(',')[i]);
		}
		// 空要素削除
		thisNgTimeArr = thisNgTimeArr.filter(Boolean);

		// 曜日取得用
		const WeekChars = ['日', '月', '火', '水', '木', '金', '土'];
		let $thisDaytWeek =　$thisDate.replace('年', '-').replace('月', '-').replace('日', '')
		let dObj = new Date($thisDaytWeek);
		let wDay = dObj.getDay();

		$('.js-input2-date').attr('value', $thisDate +'（' + WeekChars[wDay] +'）');

		$('.js-timeSelect option').each((idx,ele) => {
			if(thisNgTimeArr.indexOf($(ele).val()) !== -1) {
				$(ele).remove()
			}
		});

		// 予約できる時間の数によって「第２希望時間」「第３希望時間」の欄を消す
		if(thisNgTimeArr.length == 1 && thisNgTimeArr[0] !== 'undefined') {
			$('.js-timeBlock3').remove();
		} else if(thisNgTimeArr.length == 2) {
			$('.js-timeBlock3').remove();
			$('.js-timeBlock2').remove();
		}
	}
	// confirmから戻った際に日付を表示する
	const input2Confirm = () => {
		if(location.href.indexOf('date') === -1) {
			if($('input[name="date"][type="hidden"]').val() !== ''){
				let selectedDate = $('input[name="date"][type="hidden"]').val();
				$('.js-input2-date').attr('value', selectedDate);
			}
		}
	};

	// <個人情報の取り扱いについて>--------------------------------------------------------------------
	const privacyCheck = () => {
		$('.js-privacy-check').on('change', (e) => {
			let $this = $(e.currentTarget);
			if($this.prop('checked') === true) {
				$('.js-privacy-button').removeClass('is-disable');
			} else {
				$('.js-privacy-button').addClass('is-disable');
			}
		});
	}

	//-------------------------------------------------------------------------------
	//<ご予約状況>--------------------------------------------------------------------
	if($map === '/viewing/input1.html') {
		csvLoad();
		window.onload = function(){
			setTimeout(function(){
				radioChange();
			},200);
		}
	}
	//<お申込み情報入力>--------------------------------------------------------------------
	if($map === '/viewing/input2.html' || $map === '/viewing/confirm.html') {
		timeCheck();
		input2Confirm();
	}
	//<個人情報の取り扱いについて>--------------------------------------------------------------------
	if($map === '/viewing/privacy.html') {
		privacyCheck();
	}


})(window.jQuery, window.BOURBON);
